import { render, staticRenderFns } from "./input-range.vue?vue&type=template&id=521c2741&scoped=true"
import script from "./input-range.vue?vue&type=script&lang=ts"
export * from "./input-range.vue?vue&type=script&lang=ts"
import style0 from "./input-range.vue?vue&type=style&index=0&id=521c2741&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c2741",
  null
  
)

export default component.exports